import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
// Dev Configration
const firebaseConfig = {
  apiKey: "AIzaSyAN7RRyq6XFpzuIwLolmRjG2GHT4HpPxcE",
  authDomain: "dev-sadqajariya.firebaseapp.com",
  projectId: "dev-sadqajariya",
  storageBucket: "dev-sadqajariya.appspot.com",
  messagingSenderId: "394913796951",
  appId: "1:394913796951:web:ff4f708d529d99e793e412",
  measurementId: "G-BWLCD8DF1N"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const db = firebase.firestore();
export default firebase;
